import React, { useState } from "react";
import { Box, Container, AppBar, Toolbar, Typography, Button, Tabs, Tab } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomersTable from "../components/CustomersTable";
import ExternalApiKeys from "../components/ExternalApiKeys";
import authService from "../authProvider";

const Dashboard = () => {
  const navigate = useNavigate();
  const username = authService.getUsername();
  const [tabIndex, setTabIndex] = useState(0);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Admin Panel
          </Typography>
          {username && (
            <Typography variant="body1" sx={{ mr: 2 }}>
              {username}
            </Typography>
          )}
          <Button color="inherit" onClick={handleLogout}>
            Abmelden
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ mt: 2, mb: 4, flex: 1 }}>
        <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} sx={{ mb: 2 }}>
          <Tab label="Kunden" />
          <Tab label="API Keys" />
        </Tabs>

        {tabIndex === 0 && <CustomersTable />}
        {tabIndex === 1 && <ExternalApiKeys />}
      </Container>
    </Box>
  );
};

export default Dashboard;
